import React, { useEffect, useState } from "react";
import { Container, Row, Col, FormCheck, Button, Alert} from "react-bootstrap";
import { getToken } from "../../services/oAuth";
import { setMemoria } from "../../tools/auxiliar";
import api from "../../services/api";
import "./styles.css";

export default function Identificado({ history }) {
  let search = window.location.search;
  let params = new URLSearchParams(search);
  let idAudiencia = localStorage.getItem("idAudiencia");

  const code = params.get('code');
  const [pessoa, setPessoa] = useState([]);
  const [dados, setDados] = useState([]);
  const [nome, setNome]= useState('');
  const [email, setEmail]= useState('');
  const [instituicao, setInstituicao]= useState('');
  const [login, setLogin]= useState('Não identificado');
  const [telefone, setTelefone]= useState('');
  const [celular]= useState('');
  const [tipoInteresse]= useState('1');
  const [cpf, setCPF]= useState('');
  const [receberEmail, setReceberEmail]= useState(true);
  const [mensagem, setMensagem]= useState("Verifique seus dados, preencha o necessário e confirme!");
  const [tipoMensagem, setTipoMensagem] = useState("primary");
  const [idToken, setIdToken] = useState('0');
  const [token, setToken] = useState([]);

  localStorage.setItem("Login",login);
  
  //
  // getToken - Com o Code retornado pelo GovBr recupera Token e informações 
  //          do usuário que se identificou

  useEffect( () => { 
    async function getGovBr() {
      const res = await getToken(code)
      setDados(res);
    }
    getGovBr();
  }, [code]);

  // setForm - Recupera valores para o Formulário

  useEffect( () => { 
    async function setForm() {
      if (dados[0] === 200){
        setCPF(dados[2]);
        setNome(dados[3]);
        setTelefone(dados[4]);
        setEmail(dados[5]);
        setLogin("GOVBR");
      }
    }
    setForm();
  }, [dados]);

  useEffect( () => { 
    async function setIdent() {
      if (dados[0] === 200){
        setCPF(dados[2]);
        setNome(dados[3]);
        setTelefone(dados[4]);
        setEmail(dados[5]);
        setLogin("GOVBR");
      }
    }
    setIdent();
  }, [login]);


  // getPessoa - Recupera dados da Pessoa, pesquisando pelo e-Mail

  useEffect(() => {
    async function loadPessoa() {
      if (typeof(dados[5]) !== 'undefined'){
        const response = await api.get(`/api/pessoa/${dados[5]}/publico`);
        if (response.data.length > 0){
          setPessoa(response.data[0]);
          if (idAudiencia) {
            window.location.href= `/Consulta/${idAudiencia}`;       
          } else {
            window.location.href= "/";
          }
        }
      }
    }
    loadPessoa();
  }, [dados, idAudiencia]);

  // Grava informações da Pessoa recurperadas via gov.br

  function criticaNovoParticipante() {
    setTipoMensagem("danger");
    setMensagem("");
    var msg = "Erro: ";

    if (!telefone || telefone.length < 4){
      msg +="Telefone é obrigatório; "
    }
    if (!instituicao || instituicao.length < 1){
      msg +="Instiruição é obrigatório; "
    }
    if (pessoa && pessoa.NO_EMAIL === email){
      msg +="Participante já cadastrado";
    }
    if (msg.length > 6){
      setMensagem(msg);
      return false;
    }
    else {
      return true;
    }
  }

  async function salvaNovoParticipante() {
    const data = { 
      'Nome': nome,
      'Email': email,
      'Telefone': telefone, 
      'Celular': celular,
      'Instituicao': instituicao,
      'Interessado': tipoInteresse,
      'CPF': cpf,
      'Senha': null,
      'ReceberEmail': "N"
    };
    const response = await api.post(
      `/api/pessoa`,
      data);
    setIdToken(response.data[0].idToken);
  }
  
  useEffect(() => { 
    async function loadToken() {
      if (!isNaN(idToken) && idToken && idToken !== "0") {
        const response = await api.get(`/api/token/${idToken}`);
        setToken(response.data);
      }
    }
    loadToken();
  }, [idToken]);

  let idPessoa = "0";
  if (token && token.length>0){
    idPessoa=token[0].ID_PESSOA;
    if (idPessoa > 0 && idToken>0){
      fechaToken(idToken,idPessoa);
    }
  }

  async function fechaToken(idToken, idPessoa) {
    var receberEmailAux = "N";
    if (receberEmail){
      receberEmailAux = "S";
    }
    const senhaTratada = "";
    const data = { 
      'idPessoa': idPessoa,
      'idToken': idToken, 
      'senha': senhaTratada,
      'receberEmail': receberEmailAux,
    };
    await api.put(
      `/api/pessoa`,
    data);
    setMemoria(nome,email, true);
    if (idAudiencia) {
      window.location.href= `/Consulta/${idAudiencia}`;       
    } else {
      window.location.href= "/";
    }
  }
  // trataNome - Seta o Nome e e-Mail em memória local para ser utilizado pelo cabeçalho

  useEffect(() => {
    function trataNome() {
      if (typeof(pessoa.NO_EMAIL) !== 'undefined') {
        setMemoria(dados[3],pessoa.NO_EMAIL, true);
      }
    }
    trataNome();
  }, [pessoa, dados]);

  // Funções de Ação
  
  function handleConfirmar(){
    if (criticaNovoParticipante()){
      salvaNovoParticipante();
    }
  }
  
  function handleCancelar(){
    window.location = "/Logout";
  }

  return (
    <>
      <Container>
        <div className="quadro">
          <Row>
              <Col sm="12" className="quadro">
                  <h2>Informações do retornadas pelo Gov.Br</h2>
              </Col>
          </Row>
        </div>
        <div className="quadro">
          <Row>
            <Col sm="2">
              <label htmlFor="Nome">Nome:*</label>
            </Col>
            <Col sm="10">
              <input
                id="Nome"
                className="Bloqueado"
                type="text"
                placeholder="Nome"
                value={nome}
                readonly="readonly"
              />
            </Col>
          </Row>
          <Row>
            <Col sm="2">
              <label htmlFor="CPF">CPF:*</label> 
            </Col>
            <Col sm="10">
              <input
                id="CPF"
                className="Bloqueado"
                type="text"
                placeholder="CPF (só numeros)"
                value={cpf}
                readonly="readonly"
              />
            </Col>
          </Row>
          <Row>
            <Col sm="2">
              <label htmlFor="Email">E-mail:*</label>
            </Col>
            <Col sm="10">
              <input
                id="Email"
                className={email === "" ? "Requerido" : "Bloqueado"}
                type="email"
                placeholder="E-mail"
                onBlur={e => {
                  if (email.length > 0)
                    document.getElementById("Email").className = "Normal";
                  else
                    document.getElementById("Email").className = "Requerido";
                }}
                value={email}
                onChange={event => setEmail(event.target.value)}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="2">
              <label htmlFor="Telefone">Telefone:*</label>
            </Col>
            <Col sm="10">
              <input
                id="Telefone"
                className={telefone === "" ? "Requerido" : "Bloqueado"}
                type="tel"
                placeholder="Telefone"
                onBlur={e => {
                  const cpo = document.getElementById("Telefone").value;
                  if (cpo.length > 5)
                    document.getElementById("Telefone").className = "Normal";
                  else
                    document.getElementById("Telefone").className =
                      "Requerido";
                }}
                value={telefone}
                onChange={event => setTelefone(event.target.value)}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="2">
              <label htmlFor="Instituicao">Instituição:*</label>
                </Col>
            <Col sm="10">
              <input
                id="Instituicao"
                className="Requerido"
                type="text"
                placeholder="Instituição"
                onBlur={e => {
                  const cpo = document.getElementById("Instituicao").value;
                  if (cpo.length > 0)
                    document.getElementById("Instituicao").className =
                      "Normal";
                  else
                    document.getElementById("Instituicao").className =
                      "Requerido";
                }}
                value={instituicao}
                onChange={event => setInstituicao(event.target.value)}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="12">
              <FormCheck>
                <FormCheck.Input type={'checkbox'} 
                  className="receberEmail"
                  defaultChecked={receberEmail} 
                  onChange={event =>setReceberEmail(!receberEmail)}/>
                <FormCheck.Label>Receber informações sobre Participações Sociais da ANA?</FormCheck.Label>
              </FormCheck>
            </Col>
          </Row>
        </div>
        <div>
          <Row className={mensagem ? "mostrar" : "naoMostrar"}>
            <Col sm="12">
              <Alert variant={tipoMensagem}>
                  {mensagem}
              </Alert>
            </Col>
          </Row>
          <Row>
            <Col sm={6} align="center">
              <Button variant="success" onClick={handleConfirmar}>Confirmar</Button>
            </Col>
            <Col sm={6} align="center">
              <Button variant="warning" onClick={handleCancelar}>Cancelar</Button>
            </Col> 
          </Row>
        </div>
      </Container>
    </>
  );
}